import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchSecureRGD } from 'queries/assets-protection/secure/secureRGD'
import { SecureRGDProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function useSecureRgd({
    env,
    accessToken,
    location,
    filters,
    dynamicSubPath,
    prepend_footer_to_rows,
}: SecureRGDProps) {
    const { tenMinutes } = TIME
    const { trackEvent } = useAnalytics()

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.ASSETS_PROTECTION_SECURE_RGD, location],
        () =>
            fetchSecureRGD({
                env,
                accessToken,
                location,
                filters,
                dynamicSubPath,
                prepend_footer_to_rows,
                method: 'GET',
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )
    return { data, isLoading, isError, refetch, remove, error }
}
